import PraxFormScrollableContainer from 'components/layout/PraxFormScrollableContainer';
import moment from 'moment';
import React from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Button, Icon, List, Modal, Segment } from "semantic-ui-react";
import { getAutomaticBillRunPdfUrl } from 'services/billServices';
import styled from "styled-components";
import { AutomaticBillRunDto, AutomaticBillRunPdfResponse } from "ts-types/api.types";
import { IndexSignature } from 'utils/praxTypes';

const StyledModal = styled(Modal)`
  height: 90vh;
  width: 90vw !important;
`;

const StyledModalContent = styled(Modal.Content)`
  padding: 0 !important;
  height: 100% !important;
`;

const StyledSegmentGroup = styled(Segment.Group)`
  margin: 0 !important;
  height: 100% !important;
  border: none !important;
`;

const LeftSegment = styled(Segment)`
  width: 70% !important;
  padding: 0 !important;
`;

const RightSegment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100% !important;
  width: 30% !important;
  margin: 0 !important;
  border: none !important;
`;

const StyledScrollableContainer = styled(PraxFormScrollableContainer)`
  border-bottom: 1px solid rgba(34,36,38,.15);
`;

const ListSegment = styled.div`
  padding: 0 !important;
  height: 100% !important;
`;

const ButtonSegment = styled.div`
  padding-top: 7% !important;
  padding-bottom: 6% !important;
  align-items: center;
  padding-right: 4%;

  & button {
    float: right;
  }
`;

const IconContainer = styled.div`
  flex: 0 1 auto;
  margin-right: 10px;
  -webkit-transition: color .1s ease;
  transition: color .1s ease;
`;

const StyledListItem = styled.div<IndexSignature>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem !important;
  background: ${p => p.active ? "rgba(0,0,0,.05)" : "rgb(255, 255, 255)"};
  border-top: 1px solid rgba(34,36,38,.15);
  cursor: pointer;

  ${IconContainer} {
    color: ${p => p.active ? "rgba(0,0,0,.95)" : "rgba(0, 0, 0, .4)"} ;
  }

  }
  &:hover {
    background: rgba(0,0,0,.05);

    ${IconContainer} {
      color: rgba(0,0,0,.95);
    }
  }
`;

const StyledHeader = styled(List.Header)`
  margin-bottom: 0;
`;

const StyledContent = styled.div`
  flex: 1 1 0;
  align-items: center;
  word-break: break-all;
`;

const DownloadSection = styled.div`
  display: inline-block;
  align-items: center;
  vertical-align: top;
`;

const StyledIcon = styled(Icon)`
    margin-right: 0 !important;
    vertical-align: middle;
`;

const btnStyle = {
  background: "transparent",
  cursor: "pointer",
  padding: "5px 10px"
};

interface Props extends MessageSourceProps {
  automaticBillRun: AutomaticBillRunDto,
  automaticBillRunPdfData: AutomaticBillRunPdfResponse,
  modalOpen: boolean,
  onCloseModal: () => void
}

const AutomaticBillRunPdfModal = (props: Props) => {

  const {automaticBillRun, automaticBillRunPdfData, modalOpen, onCloseModal, getMessage} = props;

  if (!automaticBillRunPdfData) {
    onCloseModal();
  }

  const pdfId = automaticBillRunPdfData.pdfId;
  const pdfName = automaticBillRunPdfData.pdfName;

  const automaticBillRunPdfUrl: string = getAutomaticBillRunPdfUrl(pdfId, pdfName);

  return (
      <StyledModal
          open={modalOpen}
          onClose={onCloseModal}
      >
        <StyledModalContent>
          <StyledSegmentGroup horizontal>
            <LeftSegment>
              <embed
                  src={automaticBillRunPdfUrl}
                  width="100%"
                  height="100%"
                  type="application/pdf"
              />
            </LeftSegment>
            <RightSegment>
              <StyledScrollableContainer height={"100%"}>
                <ListSegment>
                  <List divided relaxed selection>
                    <StyledListItem
                        active={true}
                    >

                      <IconContainer className="icon-container">
                        <StyledIcon name="file pdf outline" size="large"/>
                      </IconContainer>
                      <StyledContent>
                        <StyledHeader as="h4">{automaticBillRunPdfData.pdfName}</StyledHeader>
                        <List.Description as="div">
                          {automaticBillRun.billDate && moment(automaticBillRun.billDate).format("DD.MM.YYYY")}
                          {automaticBillRun.user && `, ${automaticBillRun.user}`}
                        </List.Description>
                        <List.Description as="span">{automaticBillRunPdfData.pdfSize}</List.Description>
                      </StyledContent>
                      <DownloadSection>
                        <Button
                            as="a"
                            href={getAutomaticBillRunPdfUrl(pdfId, pdfName)}
                            download={automaticBillRunPdfData.pdfName}
                            icon
                            style={btnStyle}
                        >
                          <Icon name="download" size="large"/>
                        </Button>
                      </DownloadSection>
                    </StyledListItem>
                  </List>
                </ListSegment>
              </StyledScrollableContainer>
              <ButtonSegment>
                <Button compact
                        type="button"
                        onClick={onCloseModal}
                >
                  {getMessage("button.close")}
                </Button>
              </ButtonSegment>
            </RightSegment>
          </StyledSegmentGroup>
        </StyledModalContent>
      </StyledModal>
  );
};

export default withMessages(AutomaticBillRunPdfModal);
